import styled from 'styled-components'
import { theme } from '../../../theme/Global'

export const StyledList = styled.ul`
  margin: 0 auto;
  text-align: left;
  li {
    padding: 0;
  }
`
export const LocalH3Style = styled.h3`
  text-align: left;
`

export const StyledDiv = styled.div`
  color: ${theme.colors.text};
`

export const StyledLeftDiv = styled(StyledDiv)`
  text-align: left;
`
